import { BackgroundColors } from '../../enums/background-colors/background-colors.enum';

export const BackgroundColorTokenMap: { [key in BackgroundColors]: string } = {
  [BackgroundColors.THEME]: 'var(--theme-color-bg-default)',
  [BackgroundColors.PRIMARY]: 'var(--theme-color-primary)',
  [BackgroundColors.SECONDARY]: 'var(--theme-color-secondary)',
  [BackgroundColors.TERTIARY]: 'var(--theme-color-tertiary)',
  [BackgroundColors.QUATERNARY]: 'var(--theme-color-quarternary)',
  [BackgroundColors.QUINARY]: 'var(--theme-color-quinary)',
  [BackgroundColors.SCRIMMED_DEFAULT]: 'var(--theme-color-scrim-light)',
  [BackgroundColors.SCRIMMED_ALT]: 'var(--theme-color-scrim-dark)',
  [BackgroundColors.SCRIMMED_THEME]: 'var(--theme-color-scrim-light)',
  [BackgroundColors.SCRIMMED_PRIMARY]: 'var(--theme-color-scrim-primary)',
  [BackgroundColors.SYSTEM_DANGER]: 'var(--theme-color-semantic-danger-soft)',
  [BackgroundColors.SYSTEM_SUCCESS]: 'var(--theme-color-semantic-success)',
  [BackgroundColors.SYSTEM_INFO]: 'var(--theme-color-semantic-info)',
  [BackgroundColors.SYSTEM_WARNING]: 'var(--theme-color-semantic-warning)',
  [BackgroundColors.SURFACE_1]: 'var(--theme-color-semantic-on-danger-hard-strong)',
  [BackgroundColors.SURFACE_2]: 'var(--theme-color-bg-inset)',
  [BackgroundColors.SURFACE_3]: 'var(--theme-color-bg-disabled)',
  [BackgroundColors.SURFACE_4]: 'var(--theme-color-border)',
  [BackgroundColors.SURFACE_DEFAULT]: 'var(--theme-color-bg-default)',
  [BackgroundColors.SURFACE_INVERSE]: 'var(--theme-color-bg-inverse)',
  [BackgroundColors.SURFACE_ALT]: 'var(--theme-color-border)',
  [BackgroundColors.WHITE]: '#fff'
};
